import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { gsap, Power3 } from 'gsap';
import './styles/App.scss';
import { tl } from './services/translations/translations';

declare global {
    interface Window {
        webkitSpeechRecognition: any;
        SpeechRecognition: any;
    }
}


const App = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognitionRef = useRef<any>(null);
    const [listening, setListening] = useState<boolean>(false);
    const [question, setQuestion] = useState<string>("Hoelang werkte Stefan Takens?");
    const [answer, setAnswer] = useState<string>("");
    const [refreshStatus, setRefreshStatus] = useState<string>("");

    const askQuestion = async () => {
        setAnswer(""); // clear previous
        const response = await fetch("http://localhost:8000/ask", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ question })
        });


        const reader = response.body?.getReader();
        if (!reader) return;
        const decoder = new TextDecoder("utf-8");
        let done = false;



        while (!done) {
            const { value, done: doneReading } = await reader.read();
            done = doneReading;
            const chunkValue = decoder.decode(value);
            //console.log(chunkValue);
            setAnswer(prev => prev + chunkValue);
        }
    };

    const refreshIndex = async () => {
        setRefreshStatus("Index wordt vernieuwd...");
        const res = await axios.post("http://localhost:8000/refresh");
        setRefreshStatus(res.data.status);
    };

    const handleVoiceInput = () => {
        if (!SpeechRecognition) {
            alert("Spraakherkenning wordt niet ondersteund in deze browser.");
            return;
        }

        if (listening) {
            recognitionRef.current.stop();
            setListening(false);
            return;
        }

        recognitionRef.current = new SpeechRecognition();
        recognitionRef.current.lang = "nl-NL";
        recognitionRef.current.interimResults = false;

        recognitionRef.current.onresult = (event: any) => {
            const transcript = event.results[0][0].transcript;
            setQuestion(prev => prev + " " + transcript);
        };

        recognitionRef.current.onend = () => {
            setListening(false);
        };

        recognitionRef.current.start();
        setListening(true);
    };

    const menuEl = document.getElementById('menu');



    gsap.to(menuEl, {
        opacity: 1,
        pointerEvents: "all",
        duration: 0.6,
        y: 0,
        scale: 2,
        ease: Power3.easeInOut,
    });

    console.log(BASE_URL_API);
    useEffect(() => {
        //console.log(answer);
    }, [answer]);

    useEffect(() => {
        const html = `
    <p><strong>Stefan Takens</strong> heeft in totaal <strong>ruim 77 uur</strong> gewerkt volgens de beschikbare tijdregistraties.</p>

    <p>Hieronder volgt een overzicht van zijn geregistreerde werktijden:</p>

    <table border="1" cellpadding="5" cellspacing="0">
      <thead>
        <tr>
          <th>Datum</th>
          <th>Project</th>
          <th>Geregistreerde tijd</th>
        </tr>
      </thead>
      <tbody>
        <tr><td>06-02-2025</td><td>Project 2</td><td>01:14</td></tr>
        <tr><td>06-02-2025</td><td>Project 2</td><td>00:02</td></tr>
        <tr><td>07-02-2025</td><td>Project 4</td><td>01:00</td></tr>
        <tr><td>13-02-2025</td><td>Project 2</td><td>17:15</td></tr>
        <tr><td>14-02-2025</td><td>Project 2</td><td>23:42</td></tr>
        <tr><td>15-02-2025</td><td>Project 2</td><td>00:05</td></tr>
        <tr><td>11-02-2025</td><td>Project 2</td><td>07:00</td></tr>
        <tr><td>19-02-2025</td><td>Project 2</td><td>23:28</td></tr>
        <tr><td>27-02-2025</td><td>Van der Zee</td><td>00:01</td></tr>
        <tr><td>18-03-2025</td><td>Project 2</td><td>00:01</td></tr>
        <tr><td>13-06-2025</td><td>Project 2</td><td>02:50</td></tr>
        <tr><td>13-06-2025</td><td>Van der Zee</td><td>00:02</td></tr>
        <tr><td>17-06-2025</td><td>Project 4</td><td>03:00</td></tr>
        <tr><td>18-06-2025</td><td>test</td><td>00:00</td></tr>
        <tr><td>10-05-2025</td><td>Project 2</td><td>00:00</td></tr>
        <tr><td>10-05-2025</td><td>Project 4</td><td>00:00</td></tr>
        <tr><td>14-02-2025</td><td>Project 2</td><td>00:00</td></tr>
        <tr><td>13-02-2025</td><td>Project 2</td><td>00:00</td></tr>
      </tbody>
    </table>

    <p>Let op: sommige registraties tonen <strong>00:00 uur</strong> of onrealistische tijden (zoals 23:42 uur op één dag), wat kan wijzen op fouten in de tijdregistratie. De totale gewerkte tijd is berekend op basis van de som van alle realistische tijdsregistraties.</p>

    <p><strong>Totale gewerkte tijd:</strong> ongeveer <strong>77 uur en 40 minuten</strong>.</p>
  `;
        //setAnswer(html);
    }, []);

    return (
        <>
            <div className="circle-1"></div>
            <div className="circle-2"></div>
            <div className="circle-3"></div>

            <div className="app-container">
                <div className="header">
                    <h1>Assistent</h1>
                    <p>Stel een vraag over documenten of medewerkers</p>
                </div>

                <div className="card">
                    <div className="textarea">
                        <textarea
                            value={question}
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setQuestion(e.target.value)}
                            placeholder="Typ je vraag hier..."
                        />
                    </div>

                    <div className="buttons">
                        <button className="ask" onClick={askQuestion}>Vraag</button>
                        <button className="refresh" onClick={refreshIndex}>⟳ Ververs index</button>
                        <button className="speech" onClick={handleVoiceInput}>
                            {listening ? "🛑 Stop" : "🎙️ Spreek"}
                        </button>
                    </div>

                    {answer && (
                        <div className="answer-box">
                            <div dangerouslySetInnerHTML={{ __html: answer }} />
                        </div>
                    )}
                </div>

                {refreshStatus && <p style={{ textAlign: 'right', color: '#777' }}>{refreshStatus}</p>}


            </div>

        </>
    );
}

export default App;